import React, { useState } from 'react';
import TitleMain from "../../components/Title/TitleMain";
import AxiosConfig from "../../services/AxiosConfig";
import {useNavigate} from "react-router-dom";


const urls = [
    "/user",
    "/accueil",
    "/activite_seance_users/",
    "/activite_seance_users/my_seances",
    "/activite_seance_users/coach_seance_list",
    "/activite_seance_users/coach_seance/1",
    "/activite_seance_users/activites",
    "/activites",
    "/activites/",
    "/activites/entreprise/3",
    "/activites/contrat/2",
    "/activites/activite/21",
    "/activites/activite/21/seances",
    "/seances/",
    "/seances/accueil",
    "/seances/disponibles",
    "/seances/enregistrees",
    "/seances/enregistrees?sort=nom&filter=18,24",
    "/seances/effectuees",
    "/seances/seance/55",
    "/seances/seance/74",
    "/seances/date/2024-02-20",
    "/seances/referent/disponibles",
    "/seances/referent/disponibles?sort=nom&filter=18,24",
    "/seances/referent/effectuees",
    "/seances/coach/disponibles",
    "/seances/coach/disponibles?sort=nom&filter=18,24",
    "/seances/coach/effectuees",
    "/activites/types",
    "/justificatifs",
    "/justificatif/types",
    "/justificatif_get/justificatifType-65ccbb94b3855.png",
    "/justificatif_get",
    "/report",
    '/stats/activites_participation_salaries',
    '/admin',
    '/admin/entreprises',
    '/admin/entreprises/3',
    '/admin/entreprises/3/contrats',
    '/admin/entreprises/3/contrats/3',
    '/admin/entreprises/3/contrats/3/activites',
    '/admin/entreprises/3/contrats/3/activites/31',
    '/admin/entreprises/3/contrats/3/activites/31/seances',
    '/admin/entreprises/3/contrats/3/activites/31/seances/198',
    '/admin/entreprises/3/contrats/3/activites/31/seances/198/participants',
    '/admin/utilisateurs',
    '/admin/utilisateurs?role=coach',
    '/admin/utilisateurs?role=referent',
    '/admin/utilisateurs?role=utilisateur',
    '/admin/utilisateurs/8',
    '/admin/utilisateurs/8/justificatifs',
    '/admin/roles',
    '/admin/roles/ROLE_COACH',
    '/admin/roles/ROLE_COACH/justificatifs',
];

const ApiDataTestPage = props => {
    const [responseData, setResponseData] = useState(null);
    const [customUrl, setCustomUrl] = useState('');
    const navigate = useNavigate();

    if (process.env.REACT_APP_MODE === 'prod') {
        navigate('/unauthorized');
        return null;
    }

    const fetchData = async (url) => {
        try {
            const response = await AxiosConfig.get(url);
            setResponseData(JSON.stringify(response.data, null, 2));
        } catch (error) {
            console.error('Erreur lors de la récupération des données', error);
            console.error(error.response.data.message);
            setResponseData(`Erreur lors de la récupération des données : ${error.message}`);
        }
    };

    return (
        <div style={{marginLeft: "50px"}}>
            <TitleMain text={"Test de l'api"}/>

            <div style={{marginBottom: "20px"}}>
                <input
                    type="text"
                    value={customUrl}
                    onChange={(e) => setCustomUrl(e.target.value)}
                    placeholder="URL personnalisée"
                    style={{marginRight: "10px", padding: "6px", borderRadius: "6px", border: "1px solid #ccc", boxShadow: "0 0 6px #ddd", minWidth: "300px"}}
                />
                <button onClick={() => fetchData(customUrl)} style={{padding: "6px",  border: "1px solid #ccc", boxShadow: "0 0 6px #ddd", borderRadius: "6px" }}>Tester l'URL</button>
            </div>


            <div style={{display: "flex", flexDirection: "row", gap: "30px"}}>
                <ul style={{listStyle: "none"}}>
                    {urls.map((url, index) => (
                        <li key={index} onClick={() => fetchData(url)} style={{
                            padding: "6px",
                            backgroundColor: "#eee",
                            margin: "16px 0",
                            borderRadius: "6px",
                            cursor: "pointer",
                            boxShadow: "0 0 6px #ddd",
                            outline: "1px solid #ccc"
                        }}>
                            {url}
                        </li>
                    ))}
                </ul>

                {responseData && (
                    <div style={{maxWidth: "600px"}}>
                        <h3>Réponse de l'API :</h3>
                        <pre>{responseData}</pre>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ApiDataTestPage;
